import { CartUpdatedEvent } from '@theme/events';

class AuraProtect extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('input[type=checkbox]').forEach((input) => {
      input.addEventListener('change', () => this.toggle(input));
    });
  }

  async toggle(input) {
    input.disabled = true;
    const drawer = document.querySelector('cart-drawer');
    const sections = (drawer && drawer.dataset.sectionId) || '';
    const adding = input.checked;
    const url = adding ? '/cart/add.js' : '/cart/change.js';
    const body = adding
      ? { items: [{ id: Number(input.dataset.id), quantity: 1 }], sections: sections }
      : { id: String(input.dataset.id), quantity: 0, sections: sections };
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      const cart = await (await fetch('/cart.js')).json();
      document.dispatchEvent(
        new CartUpdatedEvent({}, { itemCount: cart.item_count, source: 'aura-protect', sections: data.sections })
      );
    } catch (error) {
      console.error(error);
      input.checked = !adding;
    }
    input.disabled = false;
  }
}

if (!customElements.get('aura-protect')) {
  customElements.define('aura-protect', AuraProtect);
}
